"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaInput = exports.Symbol = exports.InputWrapper = exports.Input = exports.InputStyles = exports.errorVariant = exports.sizeVariants = void 0;
const lodash_1 = require("lodash");
const react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
const stitches_config_1 = require("../../../stitches.config");
exports.sizeVariants = {
    //anything smaller than 16px/body2 will autozoom into the input on safari
    smaller: {
        fontSize: stitches_config_1.fontSizes.body3,
        padding: "0 12px",
        lineHeight: "28px",
    },
    small: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 12px",
        lineHeight: "32px",
    },
    medium: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 16px",
        lineHeight: "40px",
    },
    large: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 16px",
        lineHeight: "48px",
    },
};
exports.errorVariant = {
    true: {
        borderColor: stitches_config_1.colors.borderUiCritical,
    },
};
exports.InputStyles = {
    width: "100%",
    borderRadius: stitches_config_1.cornerRadius.radiusSm,
    border: stitches_config_1.borderStyles.solid,
    color: stitches_config_1.colors.contentPrimary,
    "@media print": {
        display: "none",
    },
    "&:focus": {
        outline: "none",
        borderColor: stitches_config_1.colors.borderUiFocused,
    },
};
exports.Input = (0, stitches_config_1.styled)("input", {
    ...exports.InputStyles,
    variants: {
        size: exports.sizeVariants,
        error: exports.errorVariant,
        prefixed: {
            true: {
                paddingLeft: "20px",
            },
        },
        postfixed: {
            true: {
                paddingRight: "20px",
            },
        },
        isDisabled: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentDisabled,
            },
        },
        isReadonly: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentPrimary,
            },
        },
    },
    compoundVariants: [
        {
            size: "smaller",
            prefixed: true,
            css: {
                paddingLeft: "18px",
            },
        },
        {
            size: "small",
            prefixed: true,
            css: {
                paddingLeft: "20px",
            },
        },
        {
            size: "medium",
            prefixed: true,
            css: {
                paddingLeft: "20px",
            },
        },
        {
            size: "large",
            prefixed: true,
            css: {
                paddingLeft: "22px",
            },
        },
        {
            size: "smaller",
            postfixed: true,
            css: {
                paddingRight: "24px",
            },
        },
        {
            size: "small",
            postfixed: true,
            css: {
                paddingRight: "24px",
            },
        },
        {
            size: "medium",
            postfixed: true,
            css: {
                paddingRight: "32px",
            },
        },
        {
            size: "large",
            postfixed: true,
            css: {
                paddingRight: "32px",
            },
        },
    ],
});
exports.InputWrapper = (0, stitches_config_1.styled)("div", {
    position: "relative",
    width: "100%",
    display: "grid",
});
exports.Symbol = (0, stitches_config_1.styled)("span", {
    position: "absolute",
    height: "100% ",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: "8px",
    fontSize: stitches_config_1.fontSizes.body3,
    color: stitches_config_1.colors.contentSecondary,
    "@media print": {
        display: "none",
    },
    variants: {
        // make sure the symbol is the same size as the input text
        size: (0, lodash_1.mapValues)(exports.sizeVariants, ({ fontSize, lineHeight, padding }) => ({
            padding,
            fontSize,
            lineHeight,
        })),
        postfix: {
            true: {
                justifySelf: "flex-end",
            },
        },
        prefix: {
            true: {
                justifySelf: "flex-start",
            },
        },
    },
});
exports.TextareaInput = (0, stitches_config_1.styled)(react_textarea_autosize_1.default, {
    ...exports.InputStyles,
    resize: "vertical",
    "@media print": {
        display: "none",
    },
    variants: {
        error: exports.errorVariant,
        size: {
            smaller: {
                fontSize: "12px",
            },
            small: {
                padding: "6px 8px",
                fontSize: "14px",
                lineHeight: "20px",
            },
            medium: {
                padding: "8px",
                fontSize: "16px",
                lineHeight: "22px",
            },
        },
        isDisabled: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentDisabled,
            },
        },
        isReadonly: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentPrimary,
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,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